import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { GroupsService } from "../services/groups.service";
import { UpdateStudentGroupRequest } from "../services/UpdateStudentGroupRequest";
import { AddStudentGroupComponent } from "./add-student-group/add-student-group.component";
import { DeleteGroupOptionsComponent } from "./delete-group-options/delete-group-options.component";
import { ImportGroupDataComponent } from "./import-group-data/import-group-data.component";
import { StudentGroupEditComponent } from "./student-group-edit/student-group-edit.component";
import { studentGroupModel } from "./studentGroupModel";
import * as moment from "moment";

@Component({
	selector: "app-edit-student-groups",
	templateUrl: "./edit-student-groups.component.html",
	styleUrls: ["./edit-student-groups.component.css", "../groups.css"],
})
export class EditStudentGroupsComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private schoolService: SchoolService,
		private groupService: GroupsService,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		// this.loadSchoolist();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	///////////////////////////////////////
	// Data
	///////////////////////////////////////

	subscription: any;

	SelectedSchoolID: any = 0;
	SelectedStudentGroup: any = null;

	lstSchool: any = [];
	lstStudentGroups: any = []; //Formatted Table data
	StudentGroupsRawDataList: any = []; //Unformatted Data from DB

	pagefirst: any = 0;
	pagerows: any = 10;

	errorMessage: any = "";

	cols = [
		{ field: "GroupName", header: "Group Name" },
		{ field: "StudentCount", header: "Student Count" },
		{ field: "ActionCount", header: "Actions Count" },
		{ field: "UpdateDate", header: "Last Update" },
		{ field: "Active", header: "Active" },
	];

	SCount: any = 0;
	ACount: any = 0;

	lstActive = ["Yes", "No"];

	ToggleText: any = "Deactivate Group";

	loading: any = false;

	///////////////////////////////////////

	///////////////////////////////////////
	// Load Data
	///////////////////////////////////////

	private loadSchoolist() {
		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.lstSchool = response;
				this.SelectedSchoolID = this.lstSchool[0].SchoolID;

				//Load Student Groups
				this.loadStudentGroups();
			},
			(error) => {}
		);
	}

	private loadStudentGroups() {
		this.loading = true;

		var result = this.groupService.GroupGetList("", this.SelectedSchoolID);
		result.subscribe(
			(response) => {
				this.StudentGroupsRawDataList = response;

				//Format data for table
				this.UpdateData();
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	UpdateData() {
		this.lstStudentGroups = [];

		for (var i = 0; i < this.StudentGroupsRawDataList.length; i++) {
			var next = this.StudentGroupsRawDataList[i];

			let val1: studentGroupModel = {
				GroupID: next.GroupID,
				GroupName: next.GroupName,
				StudentCount: next.StudentCount,
				ActionCount: next.ActionCount,
				UpdateDate: moment(new Date(next.UpdateDate)).format("YYYY/MM/DD"),
				// UpdateDate: new Date(next.UpdateDate),
				Active: next.Active == 1 ? "Yes" : "No",
			};

			this.lstStudentGroups = [...this.lstStudentGroups, val1];
		}

		this.loading = false;
	}

	///////////////////////////////////////

	///////////////////////////////////////
	// Buttons
	///////////////////////////////////////

	onRefresh() {
		this.loadStudentGroups();
	}

	onAdd() {
		this.errorMessage = "";

		//Create Popup
		var ref = this.dialogService.open(AddStudentGroupComponent, {
			header: "Add Student Group",
			width: "fit-content",
			data: {
				SchoolID: this.SelectedSchoolID,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.loadStudentGroups();
			}
		});
	}

	onRowDblClick(val) {
		this.SelectedStudentGroup = val;
		this.onEdit();
	}

	onEdit() {
		//Error Handling
		if (this.SelectedStudentGroup == null) {
			this.errorMessage = "Select a group to edit";
			return;
		}

		//Create Popup
		let popup_WidthInt = window.innerWidth - 80;
		let popup_Width = popup_WidthInt.toString() + "px";

		// var ref = this.dialogService.open(EditStudentGroupComponent, { //Old Popup
		var ref = this.dialogService.open(StudentGroupEditComponent, {
			//New Popup (Not finished)
			header: "Edit Student Group",
			// width: 'fit-content', //Old
			width: popup_Width, //New
			data: {
				SelectedStudentGroup: this.SelectedStudentGroup,

				SchoolID: this.SelectedSchoolID,
				GroupID: this.SelectedStudentGroup.GroupID,
				GroupName: this.SelectedStudentGroup.GroupName,
				Active: this.SelectedStudentGroup.Active == "Yes" ? 1 : 0,
			},
		});
		ref.onClose.subscribe((response) => {
			this.loadStudentGroups();
			this.SelectedStudentGroup = null;
			this.onRowUnselect(null);
		});
	}

	onImport() {
		//Error Handling

		var SelectedGroup: any;

		if (this.SelectedStudentGroup != null) {
			SelectedGroup = this.SelectedStudentGroup;
		} else {
			SelectedGroup = this.lstStudentGroups[0];
		}

		//Create Popup
		// var ref = this.dialogService.open(ImportStudentGroupComponent, {
		var ref = this.dialogService.open(ImportGroupDataComponent, {
			header: "Import Students into Group",
			width: "fit-content",
			data: {
				// SchoolID: this.SelectedSchoolID,
				SelectedGroup: SelectedGroup,
				lstGroup: this.lstStudentGroups,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.loadStudentGroups();
			}
		});
	}

	onToggle() {
		//Error Handling
		if (this.SelectedStudentGroup == null) {
			this.errorMessage = "Select a group to toggle";
			return;
		}

		this.loading = true;

		var changeTo = this.SelectedStudentGroup.Active == "Yes" ? 0 : 1;

		let parms: UpdateStudentGroupRequest = {
			ApplicationItemID: "",
			GroupID: this.SelectedStudentGroup.GroupID,
			GroupName: this.SelectedStudentGroup.GroupName,
			SchoolID: this.SelectedSchoolID,
			Active: changeTo,
		};

		var result = this.groupService.UpdateStudentGroup(parms);
		result.subscribe(
			(response) => {
				this.loading = false;

				if (response) {
					this.onRowUnselect(null);
					this.loadStudentGroups();
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Update Group",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	onDelete() {
		//Error Handling
		if (this.SelectedStudentGroup == null) {
			this.errorMessage = "Select a group to delete";
			return;
		}

		//
		// Confirm Delete
		//
		this.confirmationService.confirm({
			key: "mainDelete",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: "Are you sure you want to delete the group: " + this.SelectedStudentGroup.GroupName + "?",
			header: "Confirm Delete Group",
			icon: "fa",
			accept: () => {
				this.DeleteOptions();
			},
			reject: () => {
				return;
			},
		});
	}

	DeleteOptions() {
		var ref = this.dialogService.open(DeleteGroupOptionsComponent, {
			header: "Delete Group Options",
			width: "fit-content",
			data: {},
		});
		ref.onClose.subscribe((response) => {
			if (response.Delete == true) {
				this.FinishDelete(response.DeletePBIS, response.DeleteReleases, response.DeleteIncidents);
			}
		});
	}

	FinishDelete(DeletePBIS, DeleteReleases, DeleteIncidents) {
		this.loading = true;

		var result = this.groupService.DeleteStudentGroup("", this.SelectedStudentGroup.GroupID, DeletePBIS, DeleteReleases, DeleteIncidents);
		result.subscribe(
			(response: any) => {
				this.loading = false;

				if (response.Success == true) {
					this.onRowUnselect(null);
					this.loadStudentGroups();
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not delete the Group",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	///////////////////////////////////////

	///////////////////////////////////////
	// Events
	///////////////////////////////////////
	onSchoolChange(value) {
		this.errorMessage = "";

		this.SelectedSchoolID = value;

		this.loadStudentGroups();
	}

	onHandleFilter(value) {}
	onHandleSort(value) {}

	onRowSelect(value) {
		this.errorMessage = "";

		this.ToggleText = "Deactivate Group";
		if (value.data.Active == "No") {
			this.ToggleText = "Activate Group";
		}

		this.SelectedStudentGroup = value.data;
	}
	onRowUnselect(value) {
		this.ToggleText = "Deactivate Group";

		this.SelectedStudentGroup = null;
	}

	///////////////////////////////////////

	///////////////////////////////////////
	// Helpers
	///////////////////////////////////////

	AllClear(lstResp) {
		var ans = true;

		for (var z = 0; z < lstResp.length; z++) {
			var next = lstResp[z];

			if (next != "") {
				// Error message found
				ans = false;
				break;
			}
		}

		return ans;
	}

	///////////////////////////////////////
}
